package fr.frux.core.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/** Cote de la pastille dans les listes : celui des vignettes photo qu'elle remplace. */
val TreeGlyphDiscSize: Dp = 40.dp

/**
 * Part de la plaque occupee par le glyphe : la meme que sur la carte (20 dp sur une plaque de
 * 36 dp, cf. `GLYPH_PLAQUE_FRACTION` dans core-maps). Dupliquee plutot qu'importee : le design
 * system ne depend pas de core-maps.
 */
private const val GLYPH_PLAQUE_FRACTION = 20f / 36f

/**
 * Pastille espece des listes, rendue comme le marqueur correspondant sur la carte : plaque a la
 * teinte du marqueur ([fr.frux.core.designsystem.icons.treeMarkerTint]), glyphe blanc a 20/36 de
 * la plaque. Un arbre se reconnait ainsi d'un
 * ecran a l'autre, et le glyphe ne parait plus surdimensionne face aux marqueurs (retour de test
 * du 2026-09-05). Le bord blanc du marqueur, la, pour le decoller du fond de carte, est inutile
 * sur une carte de liste deja claire.
 */
@Composable
fun TreeGlyphDisc(
    glyph: ImageVector,
    tint: Color,
    modifier: Modifier = Modifier,
    size: Dp = TreeGlyphDiscSize,
) {
    Box(
        modifier = modifier.size(size).background(tint, CircleShape),
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            imageVector = glyph,
            contentDescription = null,
            tint = Color.White,
            modifier = Modifier.size(size * GLYPH_PLAQUE_FRACTION),
        )
    }
}
